import { useTrackSearchAndFiltersAnalytics } from '../../hooks/bi/useTrackSearchAndFiltersAnalytics';
import { createHOCWithHookInside } from '../createHOCWithHookInside';

/**
 * @deprecated use "useTrackSearchAndFiltersAnalytics"
 */
export const withSearchAndFiltersAnalytics = createHOCWithHookInside(
  'WithSearchAndFiltersAnalytics',
  useTrackSearchAndFiltersAnalytics,
);
